import { tapSensorFragment } from "utilities"

export const tapSensorEventsObservable = /* GraphQL */ `
subscription tapSensorEvents($input:inputTapSensorEvents!) {
    tapSensorEvents(input: $input) {
        ...${tapSensorFragment}    
    }
}
`
